import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { RootState } from "./store";

interface ThirdPartyError {
  id: string;
  name: string;
  message: string;
  error_message?: string;
  created_at: string;
  last_successful_update_at?: string | null;
  reason?: string | null;
  reconnect_exhausted?: boolean;
}

interface HealthCheck {
  id: string;
  type_id: number;
  name: string;
  is_healthy: boolean;
  reason?: string | null;
  inactive_duration: number; // in minutes
  third_party_error?: ThirdPartyError[];
  last_checked_at?: string | null;
}

interface HealthCheckState {
  healthChecks: HealthCheck[];
}

const initialState: HealthCheckState = {
  healthChecks: [],
};

const healthCheckSlice = createSlice({
  name: "healthCheck",
  initialState,
  reducers: {
    updateHealthChecks: (state, action: PayloadAction<HealthCheck[]>) => {
      const updatedChecks = action.payload.map((newCheck) => {
        const existingCheck = state.healthChecks.find(
          (check) => check.type_id === newCheck.type_id
        );
        const inactive_duration = existingCheck
          ? newCheck.is_healthy
            ? 0
            : existingCheck.is_healthy
              ? 0
              : existingCheck.inactive_duration + 2
          : newCheck.is_healthy
            ? 0
            : 2;
        return {
          ...newCheck,
          inactive_duration,
          third_party_error: newCheck.third_party_error || [],
        };
      });
      state.healthChecks = updatedChecks;
    },
  },
});

export const { updateHealthChecks } = healthCheckSlice.actions;

const healthCheckPersistConfig = {
  key: "healthCheck",
  version: 1,
  storage: storageSession,
};

export const persistedHealthCheckReducer = persistReducer(
  healthCheckPersistConfig,
  healthCheckSlice.reducer
);

export const selectHealthChecks = (state: RootState) =>
  state.healthCheck.healthChecks;
